module.exports = __webpack_public_path__ + "static/media/image_67.997beea6.png";